// 必要なライブラリやコンポーネントをインポート
import { useEffect, useState } from "react"; // Reactフック
import UserEducationTemplate, { ChoiceType, PracticeType, TestType } from "../templates/UserTestTemplate"; // テンプレートと型定義
import axios from "axios"; // HTTPリクエスト用
import { useSearchParams } from "react-router-dom"; // URLのクエリパラメータ取得用
import { useRecoilValue } from "recoil"; // Recoilの状態管理用
import userState from "../../recoil/atoms/userState"; // ユーザー情報を管理するRecoilアトム

/** 
 * UserTestPageコンポーネント
 * ユーザー向けの「問題集・テスト」ページを表示するためのコンポーネント
 * 問題集やテストのデータを取得してテンプレートに渡し表示
 */
const UserTestPage = () => {
    // URLのクエリパラメータを取得
    const [searchParams] = useSearchParams();

    // 練習問題とテスト問題の状態管理
    const [problems, setProblems] = useState<PracticeType[]>([]); // 練習問題データ
    const [questions, setQuestions] = useState<TestType[]>([]); // テスト問題データ

    // グローバルなユーザー情報を取得
    const userData = useRecoilValue(userState);

    /** 
     * 練習問題データを取得する関数
     * サーバーからユーザーIDと問題集番号に基づいて練習問題データを取得
     */
    const getGroup = async () => {
        await axios.post(process.env.REACT_APP_BE_HOST + 'workbooks/problems', {
            "userId": userData.userId, // ユーザーID
            "questionBook": searchParams.get("no") // 問題集番号
        }, {
            withCredentials: true // 認証情報を含むリクエスト
        })
        .then((res: any) => {   
            // 練習問題データを整形
            const tmpProblems: PracticeType[] = [];
            res.data?.map((p: any) => {
                tmpProblems.push({
                    practiceId: p.questionBook, // 問題集ID
                    practiceName: p.questionTitle ?? '', // 問題集名
                    triedCount: p.attemptCount ?? 0 // 挑戦回数
                });
            });
                setProblems(tmpProblems); // 練習問題データを状態に保存
        })
        .catch((e: any) => console.log(e)); // エラーハンドリング
    };

    /** 
     * テスト問題データを取得する関数
     * サーバーからユーザーIDと問題集番号に基づいてテスト問題データを取得
     */
    const getQuestions = async () => {
        await axios.post(process.env.REACT_APP_BE_HOST + 'workbooks/questions', {
            "userId": userData.userId, // ユーザーID
            "questionBook": searchParams.get("no") // 問題集番号
        }, {
            withCredentials: true
        })
        .then((res: any) => {
            // テスト問題データを整形
            const tmpQuestions: TestType[] = [];
            res.data?.map((q: any, i: number) => {
                // 選択肢をランダムに並び替え
                const choices: ChoiceType[] = q.choices;
                choices?.sort(() => 0.5 - Math.random());

                // 正解の選択肢のインデックスを収集
                const answer: number[] = [];
                choices?.forEach((c: ChoiceType, index) => {
                    if (c.isCorrect) {
                        answer.push(index);
                    }
                });

                // 整形された問題を配列に追加
                tmpQuestions.push({
                    testId: q.questionId, // 問題ID
                    question: q.questionText ?? '', // 問題文
                    choices: choices, // 選択肢
                    answer: answer, // 正解
                    explanation: q.explanation ?? [], // 解説
                });
            });
            setQuestions(tmpQuestions); // テスト問題データを状態に保存
        })
        .catch((e: any) => console.log(e)); // エラーハンドリング
    };

    /** 
     * コンポーネントの初回マウント時にデータを取得
     * 練習問題とテスト問題の両方を取得
     */
    useEffect(() => {
        getGroup(); // 練習問題データを取得
        getQuestions(); // テスト問題データを取得
    }, []);

    // テンプレートをレンダリング
    return (
        <>
            {/* テスト問題データが取得できた場合のみテンプレートを表示 */}
            {questions.length > 0 && (
                <UserEducationTemplate 
                    practices={problems} // 練習問題データ
                    tests={questions} // テスト問題データ
                    questionBook={Number(searchParams.get("no"))} // 問題集番号
                    userId={userData.userId} // ユーザーID
                />
            )}
        </>
    );
};

// UserTestPageコンポーネントをデフォルトエクスポート
export default UserTestPage;
